// Card for a connected external Supabase project. Consumers pass
// `__remoteBasePath` on the parent (RemoteProjectPicker) so clicks
// route within the consumer's own URL space (gov: /data/external,
// CMS: /tables).

export const RemoteProjectCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'Z1',
  padding: 'A',
  round: 'Z1',
  background: 'overlay',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'line',
  cursor: 'pointer',
  textAlign: 'left',
  ':hover': { borderColor: 'title' },
  transition: 'border-color 150ms ease',

  onClick: (e, el, s) => {
    const base = el.parent?.__remoteBasePath || '/data/external'
    const target = el.call('makeRemoteUrl', base, { slug: s.slug })
    const root = el.call('findRouteRoot', el) || el.getRoot()
    if (root) el.router(target, root)
  },

  TopRow: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    Left: {
      flow: 'x',
      align: 'center',
      gap: 'Z1',
      Icon: { icon: 'database', boxSize: 'A' },
      Name: {
        tag: 'span',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        text: (el, s) => s.display_name || s.slug
      }
    },
    Pill: {
      padding: 'V Z',
      round: 'Y',
      fontSize: 'Y1',
      fontWeight: '700',
      background: (el, s) => (s.enabled && s.has_secret ? 'green' : 'overlayStrong'),
      color: (el, s) => (s.enabled && s.has_secret ? 'white' : 'caption'),
      text: (el, s) => {
        if (!s.has_secret) return 'No secret'
        return s.enabled ? 'Live' : 'Disabled'
      }
    }
  },

  Meta: {
    tag: 'p',
    fontSize: 'Y2',
    color: 'caption',
    margin: '0',
    text: (el, s) => `${s.config?.project_ref || '—'} · slug: ${s.slug}`
  },
  Url: {
    tag: 'p',
    fontSize: 'Y2',
    color: 'caption',
    margin: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    text: (el, s) => s.config?.url || ''
  }
}
